import { createAction, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '../utils';
import { RESET_STATE_ACTION, RootState } from '../types';

export type EnvState = {
  env: any;
};

export const initialEnvState = {
  env: {} ,
};

const envSlice = createSlice({
  name: 'env',
  initialState: initialEnvState,
  reducers: {
    setEnv(state: EnvState, action: PayloadAction<any>): void {
      state.env = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetState, (): EnvState => initialEnvState);
  },
});

const resetState = createAction(RESET_STATE_ACTION.type);

export const { actions: envActions, reducer: envReducer, name: envKey } = envSlice;

export const selectEnvDomain = (state: RootState): EnvState => {
  return state?.env || initialEnvState;
};

export const selectEnv = createSelector([selectEnvDomain], (state: EnvState) => state.env);
